'use client';

/**
 * SysObeyaKpiFilesCard — module-scope KPI tile.
 *
 * Slices `response.totals.{total_sloc, total_files}` from the
 * system_obeya_view composite. Chrome (label, unit) comes from
 * `response.labels`. One of four tiles that replace the legacy
 * monolithic SysObeyaKpiStripCard.
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_kpi_files"
 * @see klyde_edge/ui_config/labels/system_obeya.py — mod_sum_kpi_files_*
 */

import { Code } from 'lucide-react';
import { useSystemObeyaView } from './use-system-obeya-view';
import { KpiTile, fmt } from './kpi-tile';

interface Props {
  view_name?: string;
}

export function SysObeyaKpiFilesCard({ view_name = 'module_summary' }: Props) {
  const { data, isLoading, queryKey } = useSystemObeyaView(view_name);
  const L = data?.labels ?? {};
  const t = data?.totals ?? {};
  return (
    <KpiTile
      contentKey="sys_obeya_kpi_files"
      label={L.mod_sum_kpi_files_label ?? ''}
      Icon={Code}
      value={isLoading ? '…' : fmt(t.total_sloc)}
      sub={`${fmt(t.total_files)} ${L.mod_sum_kpi_files_unit ?? ''}`.trim()}
      queryKey={queryKey}
    />
  );
}
